import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

const Copyright = () => {
return (
    <Typography variant="body2" color="textSecondary" align="center">
        {'Thai Noodle Restuarant Euless Texas Copyright © '}
        {new Date().getFullYear()}
    </Typography>
    );
}


export default function Footer() {
    return (
      <footer style={{paddingTop: 10, paddingBottom: 20}}>
      <Container maxWidth="lg">
        <Copyright/>
      </Container>
    </footer>
    );
  }